import axios from "axios";

const urls = {
  send: "https://api.omnicell.com.ua/ip2sms/",
};
const lifecellSmsService = {
  sendSms: (phone_number, text, { key, sender }) =>
    axios.post(
      urls.send,
      JSON.stringify({
        to: [{ msisdn: phone_number }],
        source: sender,
        body: { value: text },
        type: "SMS",
      }),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${key}`,
        },
      }
    ),
};

export default lifecellSmsService;
